import { render, staticRenderFns } from "./MobileSideBarSubMenu.vue?vue&type=template&id=028c60d7&scoped=true"
import script from "./MobileSideBarSubMenu.vue?vue&type=script&lang=js"
export * from "./MobileSideBarSubMenu.vue?vue&type=script&lang=js"
import style0 from "./MobileSideBarSubMenu.vue?vue&type=style&index=0&id=028c60d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c60d7",
  null
  
)

export default component.exports